<div *ngIf="errorMessage" class="error-message">
    {{ errorMessage }}
  </div>